class DateUtil {
  /**
   * timestamp를 yyyy-MM-dd 형태로 변환한다.
   * @param unix_timestamp
   * @returns {string} 변환된 날짜 데이터 (yyyy-MM-dd)
   */
  static convertTimestampToYYYYMMDD(unix_timestamp) {
    unix_timestamp = Number(unix_timestamp);
    const dateTime = new Date(unix_timestamp * 1000);
    const currentTime = new Date();

    const yyyy = dateTime.getFullYear();
    let MM = dateTime.getMonth() + 1;
    let dd = dateTime.getDate();

    MM = MM > 9 ? MM : `0${MM}`;
    dd = dd > 9 ? dd : `0${dd}`;

    if (dateTime.getFullYear() === currentTime.getFullYear() && dateTime.getMonth() === currentTime.getMonth() && dateTime.getDate() === currentTime.getDate()) {
      return `${dateTime.getHours()} : ${dateTime.getMinutes()}`;
    } else {
      return `${yyyy}-${MM}-${dd}`;
    }
  }

  // 분기기간을 리턴해주는 함수
  // ex) 2024-3-2를 입력하면 1분기인 2024-1-1, 2024-3-31 을 출력
  static getQuarterDates(dateString) {
    const inputDate = new Date(dateString);
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줌

    let startMonth, endMonth, endDay;

    if (month >= 1 && month <= 3) {
      startMonth = 1;
      endMonth = 3;
      endDay = 31;
    } else if (month >= 4 && month <= 6) {
      startMonth = 4;
      endMonth = 6;
      endDay = 30;
    } else if (month >= 7 && month <= 9) {
      startMonth = 7;
      endMonth = 9;
      endDay = 30;
    } else if (month >= 10 && month <= 12) {
      startMonth = 10;
      endMonth = 12;
      endDay = 31;
    }

    const startDate = new Date(year, startMonth - 1, 1); // 월은 0부터 시작하므로 1을 뺌
    const endDate = new Date(year, endMonth - 1, endDay); // 월은 0부터 시작하므로 1을 뺌

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더해줌
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate),
    };
  }

  // 두 달 단위로 시작 달의 첫날과 종료 달의 마지막 날을 리턴해주는 함수
  // ex) 2024-3-2를 입력하면 2024-3-1, 2024-4-30 을 출력
  static getTwoMonthPeriod(dateString) {
    const inputDate = new Date(dateString);
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줌

    // 입력된 날짜가 속한 2개월 단위의 시작 달을 계산
    const startMonth = month % 2 === 0 ? month - 1 : month;

    // 시작 달의 첫 날
    const startDate = new Date(year, startMonth - 1, 1);

    // 다음 달의 마지막 날을 구하기 위해 month + 1 달을 0일로 설정
    const endDate = new Date(year, startMonth + 1, 0);

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate),
    };
  }

  // 입력된 달의 첫번째와 마지막날을 리턴해주는 함수
  // ex) 2024-3-2를 입력하면 2024-3-1, 2024-3-31 을 출력
  static getMonthDates(dateString) {
    const inputDate = new Date(dateString);
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줌

    // 해당 월의 첫 날
    const startDate = new Date(year, month - 1, 1);
    // 해당 월의 마지막 날
    const endDate = new Date(year, month, 0); // 다음 달의 0일을 구하면 해당 달의 마지막 날이 됨

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0"); // 월은 0부터 시작하므로 1을 더해줌
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate),
    };
  }

  // 한 달 단위로 해당 달의 첫날과 마지막날을 리턴해주는 함수
  // ex) 2024-3-2를 입력하면 2024-3-1, 2024-3-31 을 출력
  static getOneMonthPeriod(dateString) {
    const inputDate = new Date(dateString);
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth() + 1; // 월은 0부터 시작하므로 1을 더해줌

    // 해당 월의 첫 날
    const startDate = new Date(year, month - 1, 1);
    // 해당 월의 마지막 날
    const endDate = new Date(year, month, 0); // 다음 달의 0일을 구하면 해당 달의 마지막 날이 됨

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate),
      month: month,
    };
  }

  /**
   * 주어진 시작 시간으로부터 경과된 시간을 계산하여 반환한다.
   *
   * @param {Date|string} startTime - 시작 시간 (Date 객체 또는 날짜 문자열)
   * @returns {string} 경과된 시간 (년, 개월, 주, 일, 시간, 분, 초 단위)
   */
  static elapsedTime(startTime) {
    if (!startTime) return '';

    const now = new Date();
    const updateDate = new Date(startTime);
    const diffMs = now - updateDate;

    // 시간 단위 변환 (밀리초 기준)
    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) {
      return `(${seconds}초 전)`;
    } else if (minutes < 60) {
      return `(${minutes}분 전)`;
    } else if (hours < 24) {
      return `(${hours}시간 전)`;
    } else if (days < 7) {
      return `(${days}일 전)`;
    } else if (weeks < 4) {
      return `(${weeks}주 전)`;
    } else if (months < 12) {
      return `(${months}개월 전)`;
    } else {
      return `(${years}년 전)`;
    }
  }
}

export default DateUtil;
